<template>
    <div>
        <!-- HEADER -->
        <header class='Pheader' id='header'>
            <div class="menuContainer">
                <div class="d-none menuInnerTop">
                    <div class="container">
                        <div class="menuIcons">
                            <ul>
                                <li>
                                    <a href="https://www.facebook.com/NTAEgy" target="_blank"
                                       class="text-dark">
                                        <i class="uil uil-facebook-f"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/c/NTAEgy" target="_blank"
                                       class="text-dark">
                                        <i class="uil uil-youtube"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/school/ntaegy"
                                       target="_blank" class="text-dark">
                                        <i class="uil uil-linkedin-alt"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/ntaegy/" target="_blank"
                                       class="text-dark">
                                        <i class="uil uil-instagram"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/NTAEgy" target="_blank"
                                       class="text-dark">
                                        <i class="uil uil-twitter"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="lang">
                            <a href='javascript:void(0)'
                               class="d-flex justify-content-center align-items-center text-dark"
                               v-if='currentLanguageLocale.name == "arabic"' @click="setLang('en')">
                                <i class='uil uil-globe p-1 fs-2 text-dark' @click="setLang('en')"></i>
                                {{ $t('en') }}
                            </a>
                            <a href='javascript:void(0)'
                               class="d-flex justify-content-center align-items-center text-dark"
                               v-if='currentLanguageLocale.name == "english"' @click="setLang('ar')">
                                <i class='uil uil-globe p-1 fs-2 text-dark' @click="setLang('ar')"></i>
                                {{ $t('ar') }}
                            </a>
                        </div>
                    </div>
                </div>

                <div class="menuInnerBottom">
                    <div class="container">
                        <nav class="navbar navbar-default">
                            <ul class="nav navbar-nav mb-0">
                                <li>
                                    <div class="menuLogo">
                                        <a href="javascript:void(0)" @click="goToHome" title="...">
                                            <img style="width: 150px"
                                                 alt="..." :src="require('@/assets/images/logo.png')"/>
                                        </a>
                                    </div>
                                </li>
                                <li v-if="store.getters['moduleAuth/isUserAuthenticated']">
                                    <a @click="goToHome" href="javascript:void(0)">
                                        <i class="uil uil-home text-danger button_icon"></i>
                                        {{ $t('home') }}
                                    </a>
                                </li>
                                <li v-if="store.getters['moduleAuth/isUserAuthenticated']">
                                    <a @click="goToPrograms" href="javascript:void(0)">
                                        <i class="uil uil-circle fs-8 text-dark button_icon"></i>
                                        {{ $t('programs') }}
                                    </a>
                                </li>
<!--                                <li v-if="store.getters['moduleAuth/isUserAuthenticated']">-->
<!--                                    <a @click="getTrainerProgram('trainer')" href="javascript:void(0)">-->
<!--                                        <i class="uil uil-circle fs-8 text-dark button_icon"></i>-->
<!--                                        {{ $t('trainer_program') }}-->
<!--                                    </a>-->
<!--                                </li>-->
                            </ul>
                            <ul class="nav navbar-nav mb-0">
                                <li>
                                    <a href='javascript:void(0)'
                                       class="d-flex justify-content-center align-items-center text-dark"
                                       style="padding: 0;"
                                       v-if='currentLanguageLocale.name == "arabic"' @click="setLang('en')">
                                        <i class='uil uil-globe p-1 fs-2 text-dark' @click="setLang('en')"></i>
                                        {{ $t('en') }}
                                    </a>
                                    <a href='javascript:void(0)'
                                       class="d-flex justify-content-center align-items-center text-dark"
                                       style="padding: 0;"
                                       v-if='currentLanguageLocale.name == "english"' @click="setLang('ar')">
                                        <i class='uil uil-globe p-1 fs-2 text-dark' @click="setLang('ar')"></i>
                                        {{ $t('ar') }}
                                    </a>
                                </li>
                                <li v-if="!store.getters['moduleAuth/isUserAuthenticated'] && !['complete_register_page','login_page'].includes(route.name)">
                                    <a @click="goToRegister" class="button text-white" style="padding: 1px 15px;"
                                       href="javascript:void(0)">
                                        <i class="uil uil-sign-in-alt text-white button_icon"></i>
                                        {{ $t('login') }}
                                    </a>
                                </li>
                                <li v-if="!store.getters['moduleAuth/isUserAuthenticated'] && !['complete_register_page','login_page'].includes(route.name)">
                                    <a @click="goToRegister" class="button text-white" style="padding: 1px 15px;"
                                       href="javascript:void(0)">
                                        <i class="uil uil-user fs-8 text-white button_icon"></i>
                                        {{ $t('register') }}
                                    </a>
                                </li>
                                <li v-if="store.getters['moduleAuth/isUserAuthenticated']">
                                    <a @click="goToAccount"
                                       href="javascript:void(0)">
                                        <i class="uil uil-user text-dark button_icon"></i>
                                        {{ $t('my_account') }}
                                    </a>
                                </li>
                                <li v-if="store.getters['moduleAuth/isUserAuthenticated']">
                                    <a @click="logout"
                                       href="javascript:void(0)">
                                        <i class="uil uil-signout text-dark button_icon"></i>
                                        {{ $t('logout') }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>

<script lang='ts'>
import { defineComponent, computed, onMounted, inject } from "vue";
  import { useI18n } from 'vue-i18n';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { MenuComponent } from '@/assets/ts/components';

  export default defineComponent({
    name: 'header-menu',
    components: {},
    mounted() {
      const vm = this;
      window.addEventListener('scroll', vm.scrollHeader);

      // /* REMOVE MENU MOBILE */
      const navLink = document.querySelectorAll('.nav_link');
      navLink.forEach(n => n.addEventListener('click', vm.linkAction));

    },
    methods: {
      linkAction() {
        const navMenu: any = document.getElementById('nav-menu');
        // When we click on each nav_link, we remove the show-menu class
        navMenu.classList.remove('show-menu');
      },
      scrollHeader() {
        const nav: any = document.getElementById('header');
        // When the scroll is greater than 200 viewport height, add the scroll-header class to the header tag
        if (window.scrollY >= 80) nav.classList.add('scroll-header');
        else nav.classList.remove('scroll-header');
      },
    },
    setup() {
      const i18n: any = useI18n();
      const router = useRouter();
      const route = useRoute();
      const store = useStore();
      const helpers: any = inject("helpers");

      onMounted(() => {
        MenuComponent.reinitialization();
      });

      i18n.locale.value = localStorage.getItem('lang')
        ? (localStorage.getItem('lang') as string)
        : 'en';

      const countries = {
        en: {
          flag: 'media/flags/united-states.svg',
          name: 'english',
        },
        ar: {
          flag: 'media/flags/egypt.svg',
          name: 'arabic',
        },
      };

      const setLang = (lang) => {
        localStorage.setItem('lang', lang);
        i18n.locale.value = lang;
        location.reload();
      };

      const currentLanguage = (lang) => {
        return i18n.locale.value === lang;
      };

      const currentLanguageLocale = computed(() => {
        return countries[i18n.locale.value];
      });

      const goToRegister = () => {
        router.push({ name: 'login_page' });
      };
      const goToAccount = () => {
        router.push({ name: 'profile_page' });
      };
      const goToPrograms = () => {
        router.push({ name: 'all_programs_page' });
      };
      const goToHome = () => {
        router.push({ name: 'dashboard' });
      };
      const logout = () => {
        store.dispatch('moduleAuth/logout').then(() => {
          location.reload();
        });
      };

      const getTrainerProgram = (id) => {
        // loading = true;
        store.dispatch("modulePrograms/findProgramDetails", {id: id})
          .then(({data}) => {
            // loading = false;
            let response = data.data;
            if (response.submissionStatus == 'NOT_COMPLETED') {
              if (response.formJsonSubmission && response.formJsonSubmission.formSubmissions) {
                router.push({ name: 'apply_program_page', params: { id: response._id } });
                return;
              }
              router.push({ name: 'show_program_page', params: { id: response._id } });
              return;
            }
            if (response.submissionStatus == 'COMPLETED') {
              router.push({ name: 'success_program_page', params: { id: response._id } });
              return;
            }

          })
          .catch((response) => {
            // loading = false;
            helpers.handleResponse(response, i18n, router, store, {});
          });
      };

      return {
        getTrainerProgram,
        goToRegister,
        goToAccount,
        goToPrograms,
        goToHome,
        logout,
        route,
        store,
        setLang,
        currentLanguage,
        currentLanguageLocale,
        countries,
      };
    },
  });
</script>

<style scoped>

</style>
